module.exports = __webpack_public_path__ + "static/media/20201129_202505_308_IMG_1788.cc2ee529.jpg";